import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubscriptionRoutingModule } from './subscription-routing.module';
import {DatatableModule} from "../../shared/components/datatable/datatable.module";
import { PrintSubscriptionComponent } from './print-subscription/print-subscription.component';
import { SettingComponent } from './setting/setting.component';


@NgModule({
  declarations: [
    PrintSubscriptionComponent,
    SettingComponent
  ],
  imports: [
    CommonModule,
    DatatableModule,
    SubscriptionRoutingModule
  ]
})
export class SubscriptionModule { }
